export default __webpack_public_path__ + "static/media/icone-bolsas.18d9caa4.png";